var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusgrey = function SvgPlusgrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.101,
    cy: 11.334,
    r: 10.601,
    fill: "#fff",
    stroke: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.056 11.6h5.046m5.046 0h-5.046m0 0v4.781m0-4.78V6.289",
    stroke: "#757575",
    strokeWidth: 1.009
  })));
};
export { SvgPlusgrey as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiByb2xlPSJwcmVzZW50YXRpb24iIGFyaWEtaGlkZGVuPSJ0cnVlIj4KPGNpcmNsZSBjeD0iMTEuMTAxNSIgY3k9IjExLjMzMzkiIHI9IjEwLjYwMTUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM3NTc1NzUiLz4KPHBhdGggZD0iTTYuMDU1NjYgMTEuNjAwOEgxMS4xMDE4TTE2LjE0NzkgMTEuNjAwOEgxMS4xMDE4TTExLjEwMTggMTEuNjAwOFYxNi4zODEzTTExLjEwMTggMTEuNjAwOFY2LjI4OTA2IiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMS4wMDkyMyIvPgo8L3N2Zz4K";